/**
 * Parse a stringified object
 *
 * @param   { string } stringifiedObject : stringified object
 * @returns { object }                   : parsed object
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function parseObject(stringifiedObject: string) {
  if (stringifiedObject === '') {
    return {};
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return JSON.parse(stringifiedObject);
}

/**
 * Stringifies an object
 *
 * @param   { object } objectToStringify  : Object that should be stringify
 * @returns { string }                    : stringified object
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function stringifyObject(objectToStringify: object) {
  if (Object.keys(objectToStringify).length === 0) {
    return '';
  }

  return JSON.stringify(objectToStringify);
}

/**
 * Parse a stringified array
 *
 * @param   { string } stringifiedArray : stringified array
 * @returns { array }                   : parsed array
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function parseArray(stringifiedArray: string) {
  if (stringifiedArray === '') {
    return [];
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return JSON.parse(stringifiedArray);
}

/**
 * Stringifies an array
 *
 * @param   { array } arrayToStringify  : array that should be stringified
 * @returns { string }                    : stringified array
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function stringifyArray(arrayToStringify: unknown[]) {
  if (arrayToStringify.length === 0) {
    return '';
  }

  return JSON.stringify(arrayToStringify);
}

/**
 * Split up a date range string into an object with a start and an end
 * Example dateRangeString: "2020-10-01:2020-10-31"
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function parseDateRangeString(dateRangeString: string) {
  return {
    start: dateRangeString.split(':')[0],
    end: dateRangeString.split(':')[1],
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isValidJSON(string: string) {
  try {
    JSON.parse(string);
    return true;
  } catch {
    return false;
  }
}
